module.exports = __webpack_public_path__ + "img/EnerArk.f47aff28.jpg";